import { NO_IMAGE } from '@/_constant';
import React, { useState } from 'react'
import { Button } from '@/_component/Common';
import { renderHeading, renderPrice, renderSubtitle, renderTitle } from '@/utility';
import { useAuthContext, useLanguageContext, useLoginToggle } from '@/hooks';

function SearchCard({ item, setRegisterLead, onClick }) {
    console.log(item,'res.item')
    const { isAuth } = useAuthContext();
    const { language } = useLanguageContext();

    const handleLoginToggle = useLoginToggle();
    const [togglePhoneNo, setTogglePhoneNo] = useState({});

    const handleChangeVisiblePhone = (item) => {
        if (!isAuth) {
            handleLoginToggle(true);
            return;
        }
        setTogglePhoneNo(prev => {
            return {
                ...prev,
                [item.id]: togglePhoneNo[item.id] ? !togglePhoneNo[item.id] : true
            }
        });
    }

    return (

        <div onClick={onClick} className="card shadow-sm overflow-hidden" style={{ minWidth: "18.1rem", maxWidth: "18.2rem", width: "100%" }}>
            <img className="card-img-top cursor-pointer" style={{ maxHeight: "10rem", height: "100%", width: "100%", margin: "auto", objectFit: "cover" }} src={!!item?.thumbnailUrl ? item.thumbnailUrl : NO_IMAGE} alt='no Image' onClick={(e) => { setRegisterLead?.(item?.id, item); }} />
            <div className='card-body cursor-pointer' onClick={(e) => { setRegisterLead?.(item?.id, item); }}>
                <div className="d-flex justify-content-between">
                    <h6 className="card-title fw-bold" style={{ textWrap: "balance" }}> {renderTitle(item)}</h6>
                    <h6 className="fw-bold" style={{ textWrap: "nowrap" }}>{renderPrice(item)}</h6>
                </div>
                <div className="d-flex flex-column gap-1 fs-7 mt-2">
                    <div className="card-subtitle mb-2 text-body-secondary">{renderHeading(item)}</div>
                    <div className="card-subtitle mb-2 text-body-secondary">{renderSubtitle(item)}</div>
                </div>
            </div>

            <div className="card-footer">
                <div className="d-flex py-2 gap-1 align-items-center justify-content-between">
                    {!togglePhoneNo[item.id] && <div>
                        <i className="bi bi-geo-alt-fill me-2"></i>
                        <span className='fs-7'>
                            {[
                                language(item?.districtCode || item?.district_code) || item?.district_name || item?.districtName,
                                language(item?.stateCode || item?.state_code) || item?.state_name || item?.stateName
                            ].filter(Boolean).join(", ")}
                        </span>
                    </div>}
                    <div>
                        <Button noSpacing primary onClick={(e) => handleChangeVisiblePhone(item)} >
                            <i className="bi-telephone-fill fs-6 me-2"></i>
                        </Button>
                        {togglePhoneNo[item.id] && <span className='fs-7'>{!!item.assigneeUserId ? item.assigneeUserId : item?.createdBy}</span>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchCard